import React from "react";
const ResultStock = ({result}) => {
    return(
        <div className="product-card__stock-infos">
            {result._stock > 2 && (<span className="instock">En stock</span>)}
            {result._stock <= 2 && result._stock > 0 &&
                (<span className="limited-stock">Stock limité</span>)}
            {result._stock === 0 && (<span className="out-of-stock">Rupture de stock</span>)}
        </div>
    )
}
export default ResultStock;